import script from "./savePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./savePage.vue?vue&type=script&setup=true&lang=ts"

import "./savePage.vue?vue&type=style&index=0&id=9c9a4338&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c9a4338"]])

export default __exports__